export default "__VITE_ASSET__DB7pyZ9D__"